import { Text } from "@/components/ui/text";
import { Center } from "@/components/ui/center";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useIsMounted from '../../hooks/mounted';
import { switchScreen } from '../../hooks/navigate';
import BasicButton from '../../components/basic/BasicButton';
import { View } from 'react-native';
import '../../assets/styles.css';
import { storeTemp } from "../../stores/mainSlice";

const data = { id: 0, list: [2, 5, 7], info: { neu: false, msg: 'Hi' } };
export default function ScreenA({ navigation, route }) {
    console.log(route)
    const name = 'ScreenA'
    const next = 'ScreenB'
    const { routeData } = route.params ? route.params : { routeData: data }
    const reduxData = useSelector((state) => state.temp.reduxData || data)
    const user = useSelector((state) => state.user)
    // const isFocused = useIsFocused();

    const dispatch = useDispatch()
    const mounted = useIsMounted()

    useEffect(() => {
        console.log('MOUNT', name, routeData, reduxData, user.preferredName)
        return () => {
            if (!mounted()) {
                console.log('UNMOUNT', name, routeData, reduxData, user.preferredName)
            }
        };
    }, [mounted])

    useEffect(() => {
        return navigation.addListener('beforeRemove', (e) => {
            // e.preventDefault()
        })
    }, [navigation])

    const onPress = () => {
        dispatch(storeTemp({ temp: { reduxData: reduxData } }))
        switchScreen(navigation, next, { routeData: routeData })
    }

    console.log('RENDER', name)
    return (
        <Center className="flex-1 m-0 bg-blue.200">
            <View
                style={{
                    $$css: true,
                    _: 'testback',
                }}>
                <Text className="text-2xl font-[800] text-primary-900 mt-6">Hello World</Text>
            </View>
            <Text className="text-2xl font-[800] text-secondary-900 mt-6">{'Data Transfer A => B'}</Text>
            <Text bold className="text-2xl text-secondary-900 mt-6">{name}</Text>
            <Text className="text-sx text-secondary-900 mt-6">{'Via navigation: ' + JSON.stringify(routeData, null, 2)}</Text>
            <Text className="text-sx text-secondary-900 mt-6">{'Via Redux: ' + JSON.stringify(reduxData, null, 2)}</Text>
            <BasicButton width='50%' bg='bg-primary-900' onPress={onPress} text={next} />
        </Center>
    );
}
/*
  cvt["next = "]=0
  cvt["name = "]=0
  cvt["msg: "]=0
*/
